"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.fetcher = exports.PROJECT_IDS = exports.API_BASE_URLS = void 0;
const enums_1 = require("../enums");
// Single Firebase project backs every flavour, so all environments share
// the same Cloud Functions host and project id.
const FUNCTIONS_HOST = 'https://us-central1-auction-site-f0831.cloudfunctions.net';
const PROJECT_ID = 'auction-site-f0831';
exports.API_BASE_URLS = {
    [enums_1.Environment.PRODUCTION]: FUNCTIONS_HOST,
    [enums_1.Environment.STAGING]: FUNCTIONS_HOST,
    [enums_1.Environment.DEVELOPMENT]: FUNCTIONS_HOST
};
exports.PROJECT_IDS = {
    [enums_1.Environment.PRODUCTION]: PROJECT_ID,
    [enums_1.Environment.STAGING]: PROJECT_ID,
    [enums_1.Environment.DEVELOPMENT]: PROJECT_ID
};
const fetcher = (url, method, body) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(`${url}`, Object.assign({ headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'DAX-Header-67-e89b-12d3-a456-426641000-R22': 'TOKEN'
        }, method: method }, (body && { body: JSON.stringify(Object.assign({}, body)) })));
    try {
        const data = yield response.json();
        return { data };
    }
    catch (error) {
        return { error };
    }
});
exports.fetcher = fetcher;
exports.methods = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE'
};
